module.exports = __webpack_public_path__ + "img/installiOS2.2497ceed.png";